<template>
  <div>
    <!-- <template v-if="!Object.keys(accounts).length">
      <info-message class="apply-loader">
        {{ $t("components.accounts.howToUseMessage") }}
      </info-message>
      <info-message class="apply-loader">
        {{ $t("components.accounts.howToAddMessage") }}
      </info-message>
    </template> -->
    <template v-if="Object.keys(accounts).length">
      <template v-for="account in accounts">
        <template v-if="link">
          <router-link
              v-bind:key="account.id"
              :to="{
              name: 'Account',
              params: { account: account.accountNumber },
            }"
          >
            <button class="pushable" @click="sendClickEvt">
              <span class="shadow"></span>
              <span class="edge"></span>
              <span class="front">
                <account :account="account" />
              </span>
            </button>
          </router-link>
        </template>
        <template v-else>
          <account v-bind:key="account.id" :account="account" />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import Account from "@/components/helpers/Account";
import { Dialog } from "vant";

export default {
  name: "Accounts",
  props: {
    link: {
      type: Boolean,
      default: true,
    },
  },
  components: { Account },
  computed: {
    accounts() {
      return this.$store.state.Auth.accounts;
    },
  },
  methods: {
    sendClickEvt() {
      this.nativeSendEvent("bottomBar", {});
    },
    deleteAccount(accountNumber) {
      Dialog.confirm({
        title: this.$t("accountList.dialogDeleteMessage") + accountNumber,
        message: this.$t("accountList.dialogQuestion"),
        cancelButtonText: this.$t("accountList.dialogCancel"),
        confirmButtonText: this.$t("accountList.dialogConfirm"),
      })
          .then(async () => {
            await this.$store.dispatch("Auth/deleteUserAccount", accountNumber);
            await this.$store.dispatch("Auth/getUserAccounts");
          })
          .catch(() => {});
    },
  },
};
</script>
<style scoped>
.pushable {
  position: relative;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  outline-offset: 4px;
  transition: filter 250ms;
}
/* Удалены стили для shadow и edge */

.front {
  display: block;
  position: relative;
  border-radius: 12px;
  font-size: 1.25rem;
  color: white;
}
.pushable:hover {
  filter: brightness(110%);
}
/* Удалены все стили, связанные с тенью */
.pushable:focus:not(:focus-visible) {
  outline: none;
}
</style>
